<template>
  <b-modal
    id="modal-add-works"
    :title="$t('add_job_type')"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    size="lg"
    centered
    no-close-on-backdrop
    @ok="onSubmit"
  >
    <!-- @show="fetchModal" -->
    <validation-observer ref="worksAddModal">
      <b-form>
        <b-row>

          <b-col md="12">
            <b-form-group :label="$t('general.title')">
              <validation-provider
                #default="{ errors }"
                :name="$t('general.title')"
                rules="required"
              >
                <b-form-input v-model="title" type="text" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group :label="$t('reference.unit')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.unit')"
                rules="required"
              >
                <v-select
                  v-model="unity"
                  label="short_title"
                  :reduce="(p) => p.id"
                  :options="GET_UNITS.results"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormCheckbox,
  BTable,
  BRow,
  BCol,
  BBadge,
  BButton,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import vSelect from "vue-select";
import { required } from "@core/utils/validations/validations";
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
  components: {
    BModal,
    BForm,
    BFormCheckbox,
    BTable,
    BRow,
    BCol,
    BBadge,
    BButton,
    BFormGroup,
    BFormInput,
    AppSearchInput,
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    object: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      title: '',
      unity: '',

      // ===============  PRIMARY_DATA_SECTION END ===============





      // ===============  OTHERS_SECTION START ===============




      // ===============  OTHERS_SECTION END ===============



      
    }
  },

  computed: {
    ...mapGetters('obectsWarehouse', ['GET_WAREHOUSE']),
    ...mapGetters("characterUnits", ["GET_UNITS"]),

  },



  async mounted(){
    await this.FETCH_UNITS({page_size: 1000})
  },



  methods: {
    ...mapActions('brigadeWorks', ['CREATE_BRIGADE_WORKS', 'FETCH_ALL_BRIGADE_WORKS']),
    ...mapActions("characterUnits", ["FETCH_UNITS"]),







    // ===============  OTHERS_SECTION START ===============


    // ===============  OTHERS_SECTION END ===============







    // ===============  ON_SUBMIT_SECTION START ===============
     async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      await this.$refs.worksAddModal.validate().then(async (success) => {
        if (!success) {
          this.$_errToast({ message: this.$t("all_fields_are_required") });
          return;
        }
        try {
          // this.$nextTick(() => {
          //   this.$route.params.editMode = false;
          //   this.$emit("onSave", this.goods);
          //   this.$bvModal.hide("modal-field");
          // });
          await this.CREATE_BRIGADE_WORKS({title: this.title, unity: this.unity})
          await this.FETCH_ALL_BRIGADE_WORKS({page_size: 1000})

          this.title = ''
          this.unity = ''
          this.$bvModal.hide('modal-add-works')
          // await this.FETCH_APPLICATIONS_MATERIAL();
          this.$_okToast();
        } catch (err) {
          console.log(err);
          // this.$_errToast('Error')
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============






    
  },
}
</script>
